import {createApi} from '@reduxjs/toolkit/dist/query/react'
import { rtkAxiosBaseSecurityQuery } from 'core/services/api/rtkAxiosBaseQuery'
import {getPermissionsQuery} from 'stateManagement/queries/permissionsQueries'

const ocaApiSlice = createApi({
  reducerPath: 'ocaApi',
  baseQuery: rtkAxiosBaseSecurityQuery,
  tagTypes: [
    'Employees',
    'TypeDocument',
    'Division',
    'Posts',
    'CeCos',
    'Profiles',
    'User',
    'CollaboratorsCash',
    'ListBanks',
    'UserBankAccount',
    'UserById',
    'CentroCosto',
    'Vehicle',
    'DocumentEvidence',
    'VehicleType',
    'DocumentoVehiculo'
  ],
  endpoints: builder => ({
    getPermissions: builder.query(getPermissionsQuery),
  }),
})

export const {middleware, reducer, reducerPath} = ocaApiSlice


export default ocaApiSlice